import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './index.css'; // Tailwind CSS
import './i18n';

function isElectron() {
    return typeof window !== 'undefined' && window.electronEnv?.isElectron === true;
}

const rootElement = document.getElementById('root');


const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <HashRouter>
            <App />
        </HashRouter>
    </React.StrictMode>
);
